
  window.onload = function(){
      setTimeout(function(){
           const combinations = [
      ["COATINGS", "AEROSPACE", 25.000000],
      ["COATINGS", "AEROSUD", 30.000000],
      ["COATINGS", "BLUE", 25.000000],
      ["COATINGS", "BULK", 35.000000],
      ["COATINGS", "ENDUSER", 25.000000],
      ["COATINGS", "ENDUSERIC", 30.000000],
      ["COATINGS", "ENDUSERLCP", 20.000000],
      ["COATINGS", "ENDUSERLP", 20.000000],
      ["COATINGS", "GREEN", 35.000000],
      ["COATINGS", "MOTUS", 37.500000],
      ["COATINGS", "OTC", 25.000000],
      ["COATINGS", "PURPLE", 45.000000],
      ["COATINGS", "RETAIL", 25.000000],
      ["COATINGS", "SAMPLE", 100.000000],
      ["COATINGS", "WOOD", 25.000000],
      ["COATINGS", "YELLOW", 30.000000],
      ["CONSUMABLE", "AEROSPACE", 30.000000],
      ["CONSUMABLE", "AEROSUD", 30.000000],
      ["CONSUMABLE", "BLUE", 25.000000],
      ["CONSUMABLE", "BULK", 40.000000],
      ["CONSUMABLE", "ENDUSER", 25.000000],
      ["CONSUMABLE", "ENDUSERIC", 25.000000],
      ["CONSUMABLE", "ENDUSERLCP", 20.000000],
      ["CONSUMABLE", "ENDUSERLP", 25.000000],
      ["CONSUMABLE", "GREEN", 35.000000],
      ["CONSUMABLE", "MOTUS", 25.000000],
      ["CONSUMABLE", "OTC", 25.000000],
      ["CONSUMABLE", "PURPLE", 35.000000],
      ["CONSUMABLE", "RETAIL", 25.000000],
      ["CONSUMABLE", "SAMPLE", 100.000000],
      ["CONSUMABLE", "WOOD", 30.000000],
      ["CONSUMABLE", "YELLOW", 30.000000],
      ["EQUIPMENT", "AEROSPACE", 30.000000],
      ["EQUIPMENT", "AEROSUD", 30.000000],
      ["EQUIPMENT", "BLUE", 25.000000],
      ["EQUIPMENT", "BULK", 40.000000],
      ["EQUIPMENT", "ENDUSER", 25.000000],
      ["EQUIPMENT", "ENDUSERIC", 25.000000],
      ["EQUIPMENT", "ENDUSERLCP", 20.000000],
      ["EQUIPMENT", "ENDUSERLP", 25.000000],
      ["EQUIPMENT", "GREEN", 35.000000],
      ["EQUIPMENT", "MOTUS", 25.000000],
      ["EQUIPMENT", "OTC", 25.000000],
      ["EQUIPMENT", "PURPLE", 35.000000],
      ["EQUIPMENT", "RETAIL", 25.000000],
      ["EQUIPMENT", "SAMPLE", 100.000000],
      ["EQUIPMENT", "WOOD", 30.000000],
      ["EQUIPMENT", "YELLOW", 30.000000]
    ];
        
    const elements = document.querySelectorAll('[data-type][data-customer]');
        
      const conditions = Array.from(elements).map(element => {
        const leftItem = element.dataset.type;
        const rightItem = element.dataset.customer;
        return { left: leftItem, right: rightItem, element };
      });
    
      for (const [left, right, value] of combinations) {
        for (const { left: leftHTML, right: rightHTML, element } of conditions) {
          if(!element.getAttribute('discounted')){
          if (left === leftHTML && rightHTML.toUpperCase().includes(right)) {
            var p = element.querySelector(':scope > :nth-child(2) > :nth-child(5) > :first-child > :first-child > :nth-child(2)').innerText.split("R ")[1].replace(",","");
            p = p*((100 - value)/100);
            element.querySelector(':scope > :nth-child(2) > :nth-child(5) > :first-child > :first-child > :nth-child(2)').innerText = "R "+p.toFixed(2);
            element.setAttribute('discounted','true');
          }   
          }
        }
      }   
    },100)



const targetNode = document.getElementById('gf-grid');
const config = { attributes: true, childList: true, subtree: true };
const callback = function(mutationsList, observer) {
    for(const mutation of mutationsList) {
       if (mutation.type === 'childList') {
          discountCheck();
          break;
        }
       
    }
};
const observer = new MutationObserver(callback);
observer.observe(targetNode, config);
    
}

    function discountCheck(){
       setTimeout(function(){
           const combinations = [
      ["COATINGS", "AEROSPACE", 25.000000],
      ["COATINGS", "AEROSUD", 30.000000],
      ["COATINGS", "BLUE", 25.000000],
      ["COATINGS", "BULK", 35.000000],
      ["COATINGS", "ENDUSER", 25.000000],
      ["COATINGS", "ENDUSERIC", 30.000000],
      ["COATINGS", "ENDUSERLCP", 20.000000],
      ["COATINGS", "ENDUSERLP", 20.000000],
      ["COATINGS", "GREEN", 35.000000],
      ["COATINGS", "MOTUS", 37.500000],
      ["COATINGS", "OTC", 25.000000],
      ["COATINGS", "PURPLE", 45.000000],
      ["COATINGS", "RETAIL", 25.000000],
      ["COATINGS", "SAMPLE", 100.000000],
      ["COATINGS", "WOOD", 25.000000],
      ["COATINGS", "YELLOW", 30.000000],
      ["CONSUMABLE", "AEROSPACE", 30.000000],
      ["CONSUMABLE", "AEROSUD", 30.000000],
      ["CONSUMABLE", "BLUE", 25.000000],
      ["CONSUMABLE", "BULK", 40.000000],
      ["CONSUMABLE", "ENDUSER", 25.000000],
      ["CONSUMABLE", "ENDUSERIC", 25.000000],
      ["CONSUMABLE", "ENDUSERLCP", 20.000000],
      ["CONSUMABLE", "ENDUSERLP", 25.000000],
      ["CONSUMABLE", "GREEN", 35.000000],
      ["CONSUMABLE", "MOTUS", 25.000000],
      ["CONSUMABLE", "OTC", 25.000000],
      ["CONSUMABLE", "PURPLE", 35.000000],
      ["CONSUMABLE", "RETAIL", 25.000000],
      ["CONSUMABLE", "SAMPLE", 100.000000],
      ["CONSUMABLE", "WOOD", 30.000000],
      ["CONSUMABLE", "YELLOW", 30.000000],
      ["EQUIPMENT", "AEROSPACE", 30.000000],
      ["EQUIPMENT", "AEROSUD", 30.000000],
      ["EQUIPMENT", "BLUE", 25.000000],
      ["EQUIPMENT", "BULK", 40.000000],
      ["EQUIPMENT", "ENDUSER", 25.000000],
      ["EQUIPMENT", "ENDUSERIC", 25.000000],
      ["EQUIPMENT", "ENDUSERLCP", 20.000000],
      ["EQUIPMENT", "ENDUSERLP", 25.000000],
      ["EQUIPMENT", "GREEN", 35.000000],
      ["EQUIPMENT", "MOTUS", 25.000000],
      ["EQUIPMENT", "OTC", 25.000000],
      ["EQUIPMENT", "PURPLE", 35.000000],
      ["EQUIPMENT", "RETAIL", 25.000000],
      ["EQUIPMENT", "SAMPLE", 100.000000],
      ["EQUIPMENT", "WOOD", 30.000000],
      ["EQUIPMENT", "YELLOW", 30.000000]
    ];
        
    const elements = document.querySelectorAll('[data-type][data-customer]');
    
      const conditions = Array.from(elements).map(element => {
        const leftItem = element.dataset.type;
        const rightItem = element.dataset.customer;
        return { left: leftItem, right: rightItem, element };
      });
    
      for (const [left, right, value] of combinations) {
        for (const { left: leftHTML, right: rightHTML, element } of conditions) {
          if(!element.getAttribute('discounted')){
          if (left === leftHTML && rightHTML.toUpperCase().includes(right)) {
            var p = element.querySelector(':scope > :nth-child(2) > :nth-child(5) > :first-child > :first-child > :nth-child(2)').innerText.split("R ")[1].replace(",","");
            p = p*((100 - value)/100);
            element.querySelector(':scope > :nth-child(2) > :nth-child(5) > :first-child > :first-child > :nth-child(2)').innerText = "R "+p.toFixed(2);
            element.setAttribute('discounted','true');
          }   
          }
        }
      }   
    },100);
    }
